import { render, staticRenderFns } from "./ManagerButtons.vue?vue&type=template&id=794f9c3e"
import script from "./ManagerButtons.vue?vue&type=script&lang=js"
export * from "./ManagerButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports